import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useEffect, useState } from 'react';
import { CreateExperience } from '../experience-editor/create-experience/CreateExperience';
import { Iframe } from './Iframe';

interface WelcomeDialogProps {
  visible: boolean;
  onHide: () => void;
}

export const WelcomeDialog = ({ visible, onHide }: WelcomeDialogProps) => {
  const [displayVisible, setDisplayVisible] = useState(visible);

  useEffect(() => {
    setDisplayVisible(visible);
  }, [visible]);

  const handleHide = () => {
    setDisplayVisible(false);
    onHide();
  };

  const LoomVideo = () => (
    <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0 }}>
      <Iframe
        src="https://www.loom.com/embed/f9246d27a36744098254ec49c4ca9302?sid=3f80fe65-7b41-4f5d-8940-b13ba7b5341d"
        frameBorder="0"
        webkitallowfullscreen
        mozallowfullscreen
        allowfullscreen
        style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '80%' }}
      />
    </div>
  );

  const handleScheduleCall = () => {
    window.open('https://calendly.com/hsspal/hql30m', '_blank', 'noopener');
  };

  const footer = (
    <div className="flex justify-content-end flex-wrap">
      <CreateExperience label="Import Your Site" />
      <Button
        label="Schedule Support Call"
        onClick={handleScheduleCall}
        className="p-button-secondary p-button-outlined"
      />
    </div>
  );

  return (
    <Dialog
      visible={displayVisible}
      onHide={handleHide}
      header="Welcome to Customerized.ai!"
      footer={footer}
      modal={true}
      maximizable={false}
      closable={true}
      closeOnEscape={true}
      draggable={true}
      style={{ width: '70%', maxWidth: '100%' }}
      contentStyle={{ maxHeight: '80vh', overflowY: 'auto' }}
      pt={{
        mask: {
          style: {
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            backdropFilter: 'blur(10px)',
          },
        },
      }}
    >
      <div>
        B2B Prospects want to explore your features, but they&apos;re only going to be there for a few seconds.
        Personalize their experience based on their intent so they convert, and not bounce. Import your site to get
        started!
      </div>
      <LoomVideo />
    </Dialog>
  );
};
